import { BaseContainerModel } from '../base-container.model';
import { bl_hc_medical_test_hdr_RowClass, bl_hc_medical_test_hdr_RowInterface } from '../../dbschema/bl_hc_medical_test_hdr.model';


export class HcMedicalTestHdrContainerModel extends BaseContainerModel {
  bl_hc_medical_test_hdr: bl_hc_medical_test_hdr_RowInterface = new bl_hc_medical_test_hdr_RowClass();
}